import styled from "styled-components"
import CustomButton from "../../components/custom-button/custom-button.component"
import Container from "@mui/material/Container"

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-top: 0;
  height: 100%;

  ${({ theme }) => theme.breakpoints.up("md")} {
    padding-top: 10rem;
    justify-content: flex-start;
  }
  > div {
    .gatsby-image-wrapper {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      height: 100vh !important;
    }
  }

  &:after {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
      linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
      linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
      linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2));
    height: 100%;
    width: 100%;
    z-index: 1;
  }
`

export const CustomContainer = styled(Container)`
  ${({ theme }) => theme.breakpoints.down("md")} {
    align-self: center;
    padding-bottom: 89px;
    padding-left: 2rem;
    padding-right: 2rem;
  }
`

export const Title = styled.h1`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: 400;
  position: relative;
  z-index: 4;

  font-size: ${({ theme }) => theme.typography.pxToRem(40)};
  line-height: ${({ theme }) => theme.typography.pxToRem(61)};
  display: flex;
  align-items: center;
  text-align: center;
  text-transform: uppercase;
  color: #ffffff;

  ${({ theme }) => theme.breakpoints.up("sm")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(50)};
    line-height: ${({ theme }) => theme.typography.pxToRem(71)};
  }

  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(76)};
    line-height: ${({ theme }) => theme.typography.pxToRem(91)};
  }
`

export const Button = styled(CustomButton)`
  z-index: 5;
  svg {
    min-height: 24px;
    min-width: 28px;
    margin-right: 1rem;
  }
  padding: ${({ theme }) => theme.typography.pxToRem(17)}
    ${({ theme }) => theme.typography.pxToRem(28)};

  &.red {
    max-width: 112px;
  }

  &.lightBorder {
    max-width: 220px;
  }

  font-style: normal;
  font-weight: 600;
  font-size: ${({ theme }) => theme.typography.pxToRem(16)};
  line-height: 1rem;
  text-transform: capitalize;
  text-align: center;

  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(18)};
    line-height: 1rem;
  }
`
